import {
  getUserDetails as getUserDetailsApi,
  patchUpdateUser
} from "../../../helpers/user_helper";

// action
import {
  userGetSuccess,
  userGetError,
  userUpdateSuccess,
  userUpdateError,
} from "./reducer";

export const getUserDetails = (id) => async (dispatch) => {
  try {
    let response;
    response = getUserDetailsApi(id);
    const data = await response;
    if (data) {
      dispatch(userGetSuccess(data));
    }
  } catch (error) {
    dispatch(userGetError(error));
  }
}

export const updateUser = (id, payload) => async (dispatch) => {
  try {
    let response;
    response = patchUpdateUser(
      id,
      payload
    );
    const data = await response;
    if (data) {
      dispatch(userUpdateSuccess(data));
    }
  } catch (error) {
    dispatch(userUpdateError(error));
  }
}
